import type {RouteRecordRaw} from 'vue-router'

import BatchRename from "@/pages/softs/BatchRename.vue"
import AudioConverter from "@/pages/softs/AudioConverter.vue"
import OFDConverter from "@/pages/softs/OFDConverter.vue"

export default <RouteRecordRaw[]>[
  {
    name: 'soft-batchrename', path: '/softs/batchrename',
    component: BatchRename,
  },
  {
    name: 'soft-audioconverter', path: '/softs/audioconverter',
    component: AudioConverter,
  },
  {
    name: 'soft-ofdconverter', path: '/softs/ofdconverter',
    component: OFDConverter,
  },
]
